import { CustomerRepository } from "../../../../data/repository/customer/CustomerRepository";
import { Order } from "../../../model/Order";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetCustomerOrdersUseCase {
  invoke: (
    customerId: string,
    skip?: number,
    limit?: number
  ) => Promise<ResponseState<Array<Order>>>;
}

export class GetCustomerOrdersUseCaseImpl implements GetCustomerOrdersUseCase {
  private repository: CustomerRepository;

  constructor(repository: CustomerRepository) {
    this.repository = repository;
  }

  async invoke(
    customerId: string,
    skip?: number,
    limit?: number
  ): Promise<ResponseState<Array<Order>>> {
    try {
      let response = await this.repository.getOrders(customerId, skip, limit);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
